import React, { useState, useEffect } from "react";
import Pagination from "react-js-pagination";
import usePermission from "../../utils/usePermission";
import UnAuthorized from "../UnAuthorized/UnAuthorized";
import { MdEdit } from "react-icons/md";
import FullPageLoading from "../../components/FullPageLoading/FullPageLoading";
import { CiSearch } from "react-icons/ci";
import useUsersListing from "../../customHooks/UsersListing/useUsersListing";
import { format, parseISO, subMinutes } from "date-fns";
// import placeholder from "../../assets/images/placeholder.png";
import { useNavigate } from "react-router";
import CreateUserModal from "../CreateUser/CreateUserModal";

const UsersListing = () => {
  const navigate = useNavigate();
  const {
    allUsers,
    currentPage,
    totalCount,
    searchTerm,
    loader,
    handlePageClick,
    handleSearch,
    usersPerPage,
    openModal,
    setOpenModal,
    fetchTenants,
    userData,
    setUserData,
  } = useUsersListing();
  const canRead = usePermission("TEANANT_READ");
  const canWrite = usePermission("TEANANT_CREATE");
  const canUpdate = usePermission("TEANANT_UPDATE");

  return (
    <div>
      {!canRead ? (
        <div className="container">
          <div className="mainHeader">
            <h1 className="text-lg font-semibold">Users Listing</h1>
            <div className="flex gap-4">
              {!canWrite && (
                <button
                  className="bg-blue-600 text-white px-4 py-2 rounded-md shadow hover:bg-blue-700"
                  onClick={() => {
                    setOpenModal(true);
                    // navigate("/tenant/create");
                  }}
                >
                  + Create User
                </button>
              )}
            </div>
          </div>
          <div className="mainHeader">
            <div className="flex gap-4">
              <div className="form-group">
                <label htmlFor="featureCategoryId">Search By Name</label>
                <div className="search-container">
                  <input
                    type="text"
                    placeholder="Search By Name..."
                    className="search-input"
                    value={searchTerm}
                    onChange={handleSearch}
                  />

                  <CiSearch className="search-icon" />
                </div>
              </div>
            </div>
          </div>
          {!loader ? (
            <div className="mainContainer">
              {/* <div className="flex justify-between items-center mb-4">
                <div className="text-lg font-medium">
                  <span className="text-gray-700">{allUsers.length}</span>{" "}
                  Total Tenants |{" "}
                  <span className="text-green-600">{activeCount}</span> Active
                  Tenants |{" "}
                  <span className="text-red-600">{inactiveCount}</span> Inactive
                  Tenants
                </div>
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    className="form-checkbox h-5 w-5 text-blue-600 mr-2"
                    checked={excludeInactive}
                    onChange={handleExcludeInactiveChange}
                  />
                  <span className="text-gray-600">
                    Exclude Inactive Customers
                  </span>
                </div>
              </div> */}

              <div className="table-container">
                <table className="data-table">
                  <thead>
                    <tr>
                      <th>User Name</th>
                      <th>User Email</th>
                      <th>Role</th>
                      <th>Created At</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {allUsers.length > 0 ? (
                      allUsers.map((tenant, index) => {
                        const utcCreaedAt = tenant.dtCreatedAt
                          ? subMinutes(parseISO(tenant.dtCreatedAt), 330)
                          : "";

                        const formattedTime = format(
                          utcCreaedAt,
                          "MMMM d, yyyy"
                        );

                        return (
                          <tr key={tenant.iTenantId}>
                            <td>{tenant.sName}</td>
                            <td>{tenant.sEmail}</td>
                            <td>{tenant.sRole}</td>
                            <td>{formattedTime}</td>
                            <td>
                              <div className="actionBtns flex gap-4">
                                <button
                                  className="editButtom"
                                  onClick={() => {
                                    setOpenModal(true);
                                    setUserData(tenant);
                                  }}
                                >
                                  <MdEdit />
                                </button>
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center text-gray-600">
                          No Users Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {totalCount !== 0 && (
                <div className="mt-6 flex justify-between items-center">
                  <span className="text-gray-600">
                    Showing {(currentPage - 1) * usersPerPage + 1} to{" "}
                    {Math.min(currentPage * usersPerPage, totalCount)} of{" "}
                    {totalCount} entries
                  </span>
                  {totalCount > usersPerPage && (
                    <Pagination
                      activePage={currentPage}
                      itemsCountPerPage={usersPerPage}
                      totalItemsCount={totalCount}
                      pageRangeDisplayed={5}
                      onChange={handlePageClick}
                      nextPageText={">"}
                      prevPageText={"<"}
                      firstPageText={"<<"}
                      lastPageText={">>"}
                      itemClass="page-item"
                      linkClass="page-link"
                    />
                  )}
                </div>
              )}
            </div>
          ) : (
            <div>
              {" "}
              <FullPageLoading />
            </div>
          )}
        </div>
      ) : (
        <UnAuthorized />
      )}

      <CreateUserModal
        show={openModal}
        onHide={() => {
          setOpenModal(false);
          setUserData({});
        }}
        fetchUsers={fetchTenants}
        userData={userData}
        id={userData && userData?.id}
      />
    </div>
  );
};

export default UsersListing;
